import { useEffect, useState } from "react";
import { authApi } from "../../lib/authApi";
import { KpiGrid, EmptyNote, pct, hrs, num } from "./AnalyticsShared";

export const PartnerPerformance = () => {
  const [data, setData] = useState(null);
  useEffect(() => { authApi.get("/partner/analytics").then((r) => setData(r.data)).catch(() => setData({ error: true })); }, []);
  if (!data || data.error) return null;
  return (
    <section className="mb-8" data-testid="partner-performance">
      <h2 className="text-base md:text-lg font-semibold font-heading mb-3">Your performance</h2>
      {data.empty ? <EmptyNote testId="partner-performance-empty" /> : (
        <KpiGrid cols="sm:grid-cols-2 lg:grid-cols-4" items={[
          { label: "Work orders assigned", value: num(data.assignments), hint: `${num(data.accepted)} accepted · ${num(data.declined)} declined · ${num(data.pending)} pending`, testId: "partner-kpi-assignments" },
          { label: "Response time", value: hrs(data.response_time), hint: `median · n=${data.response_time.sample}`, testId: "partner-kpi-response" },
          { label: "Production time", value: hrs(data.production), hint: `accept → complete · n=${data.production.sample}`, testId: "partner-kpi-production" },
          { label: "First-pass yield", value: pct(data.quality.first_pass_yield), hint: `${data.quality.first_cycle_passed}/${data.quality.first_cycle_inspections} first inspections passed`, testId: "partner-kpi-fpy" },
          { label: "Rework", value: pct(data.quality.rework_rate), hint: `${data.quality.rework_cycles_total} cycle(s)`, testId: "partner-kpi-rework" },
          { label: "On-time delivery", value: pct(data.delivery.on_time_rate), hint: `${data.delivery.on_time}/${data.delivery.delivered} delivered`, testId: "partner-kpi-ontime" },
          { label: "Active work orders", value: num(data.active_orders), testId: "partner-kpi-active" },
        ]} />
      )}
    </section>
  );
};
